// A text and a code as the search of the domains compares them (ADR-117): the client marks what a hit answers, and
// the fake gateway of the e2e suite matches, with the same folding as the database. Without imports, so both can
// import it.

// what `unaccent` turns into other letters, in Latin-1 and Latin Extended-A: for NFD they are not a letter with an
// accent
const LETTERS: Record<string, string> = {
  ø: "o",
  æ: "ae",
  œ: "oe",
  ł: "l",
  ß: "ss",
  đ: "d",
  ð: "d",
  þ: "th",
  ħ: "h",
  ı: "i",
  ĳ: "ij",
  ĸ: "q",
  ŀ: "l",
  ŋ: "n",
  ŧ: "t",
  ſ: "s",
  ŉ: "'n",
};
const NOT_DECOMPOSED = new RegExp(`[${Object.keys(LETTERS).join("")}]`, "g");

/** Lower case, without accents: as `app.search_text` compares. */
export const foldText = (text: string) =>
  text
    .toLowerCase()
    .replace(NOT_DECOMPOSED, (c) => LETTERS[c] ?? c)
    .normalize("NFD")
    .replace(/\p{M}/gu, "");

/** Only letters and digits, in upper case: as `app.code_key` compares (`po-0001` is `PO0001`). */
export const codeKeyOf = (text: string) =>
  foldText(text)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
